import React, { useState, useEffect } from 'react';
import apiFetch from '../../../../utils/api';
import Preloader from '../../../../components/Preloader/Preloader';
import Pagination from '../../../../components/Pagination/Pagination';
import './AdminStyles.css';

const AdminTotalWithdrawals = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [stats, setStats] = useState({ total: 0, approved: 0, pending: 0, rejected: 0 });
  const [acting, setActing] = useState(null);

  const fetchData = () => {
    setLoading(true);
    apiFetch(`/api/admin/withdrawals/all?page=${page}`)
      .then(res => res.json())
      .then(res => { 
        setData(res.withdrawals || []); 
        setTotalPages(res.totalPages || 1);
        setStats(res.stats || { total: 0, approved: 0, pending: 0, rejected: 0 });
        setLoading(false); 
      })
      .catch(() => setLoading(false));
  };
  useEffect(fetchData, [page]);

  const getStatusClass = (s) => s === 'Approved' ? 'approved' : s === 'Rejected' ? 'rejected' : 'pending';

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this withdrawal record?')) return;
    setActing(id);
    const res = await apiFetch(`/api/admin/withdrawals/${id}/delete`, { method: 'DELETE' });
    const d = await res.json();
    if (d.success) fetchData();
    setActing(null);
  };

  return (
    <div className="admin-page">
      <div className="admin-breadcrumb">🏠 / Admin / Total Withdrawals</div>
      <h2 className="admin-title">Total Withdrawals</h2>
      <div className="admin-stats-bar">
        <div className="admin-stat-chip blue">{stats.total} Total</div>
        <div className="admin-stat-chip green">{stats.approved} Approved</div>
        <div className="admin-stat-chip orange">{stats.pending} Pending</div>
        <div className="admin-stat-chip red">{stats.rejected} Rejected</div>
      </div>
      <div className="admin-card">
        <div className="admin-card-header">All Withdrawal Records</div>
        <div className="admin-card-body">
          {loading ? (
            <Preloader message="Fetching withdrawal history..." fullScreen={false} />
          ) : data.length === 0 ? (
            <div className="admin-empty">No withdrawals</div>
          ) : (
            <>
              <div className="admin-table-wrap">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Username</th>
                      <th>Email</th>
                      <th>Amount</th>
                      <th>Description</th>
                      <th>Account #</th>
                      <th>Account Title</th>
                      <th>Team</th>
                      <th>Level</th>
                      <th>Payment Method</th>
                      <th>Status</th>
                      <th>Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map(row => (
                      <tr key={row.id}>
                        <td>{row.id}</td>
                        <td><strong>{row.username}</strong></td>
                        <td>{row.email}</td>
                        <td><span className="user-balance-chip">Rs. {row.amount}</span></td>
                        <td><span style={{ color: 'var(--awp-accent)', fontWeight: '500' }}>Ads watch earning</span></td>
                        <td>{row.accountNumber || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td>{row.accountTitle || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td>{row.team || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td><span className="status-badge approved">{row.userLevel}</span></td>
                        <td>{row.paymentMethod || <span style={{ color: 'var(--awp-text-subtle)' }}>—</span>}</td>
                        <td><span className={`status-badge ${getStatusClass(row.status)}`}>{row.status}</span></td>
                        <td>{row.createdAt}</td>
                        <td><button className="admin-btn admin-btn--reject" onClick={() => handleDelete(row.id)} disabled={acting === row.id}>🗑</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Pagination 
                currentPage={page} 
                totalPages={totalPages} 
                onPageChange={setPage} 
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminTotalWithdrawals;
